import { r as registerInstance, h, H as Host } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { a1 as vUndefOr, a as vString, S as vOneOf, Z as vObjectWith, Q as vBoolean } from './validation-02b8d01d.js';
import { t as tuple } from './types-6f6b2fba.js';
import './i18n-939e2dee.js';

const badgeVersions = tuple('success', 'warning', 'error', 'info');
const badgeSizes = tuple('xs', 'sm', 'md', 'lg');

const dsBadgeCss = "ds-badge{display:-ms-inline-flexbox;display:inline-flex;position:relative;-ms-flex-negative:0;flex-shrink:0;vertical-align:middle}ds-badge .badge{position:absolute;top:0;right:0;transform:scale(1) translate(100%, -70%);transform-origin:100% 0%;display:-ms-flexbox;display:flex;z-index:1;-ms-flex-wrap:wrap;flex-wrap:wrap;box-sizing:border-box;transition:transform 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;-ms-flex-align:center;align-items:center;line-height:1;-ms-flex-line-pack:center;align-content:center;border-radius:200px;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;font-weight:bold}ds-badge[is-dot] .badge{height:0.5rem !important;min-width:0.5rem !important;padding:0 !important;transform:scale(1) translate(140%, -50%)}ds-badge[size='xs'] .badge{height:1rem;min-width:1rem;font-size:0.6rem;padding:0 0.2rem 0.1rem}ds-badge[size='sm'] .badge{height:1.125rem;font-size:0.75rem;min-width:1.125rem;padding:0.1rem 0.3rem}ds-badge[size='md'] .badge{height:1.3rem;font-size:0.8rem;min-width:1.3rem;padding:0 0.4rem}ds-badge[size='lg'] .badge{height:1.5rem;font-size:0.9rem;min-width:1.5rem;padding:0 0.5rem;border-radius:1rem}ds-badge[version='success'] .badge{color:var(--white);background-color:var(--green-500)}ds-badge[version='warning'] .badge{color:var(--white);background-color:var(--orange-500)}ds-badge[version='error'] .badge{color:var(--white);background-color:var(--red-500)}ds-badge[version='info'] .badge{color:var(--white);background-color:var(--blue-600)}ds-badge[version='success'][has-shadow] .badge{box-shadow:0 0 5px 0 #7abe78}ds-badge[version='error'][has-shadow] .badge{box-shadow:0 0 5px 0 #f5555a}ds-badge[version='warning'][has-shadow] .badge{box-shadow:0 0 5px 0 #e8933c}ds-badge[version='info'][has-shadow] .badge{box-shadow:0 0 5px 0 #7691ff}";

const DsBadge = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.propError = {};
    this.label = undefined;
    this.version = 'success';
    this.size = 'sm';
    this.customPosition = undefined;
    this.hasShadow = false;
    this.isDot = false;
  }
  watchLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'label', 'string', vUndefOr(vString)))
      return;
  }
  watchVersion() {
    /* istanbul ignore if */
    if (!propCheck(this, 'version', badgeVersions.join(' | '), vOneOf(badgeVersions)))
      return;
  }
  watchSize() {
    /* istanbul ignore if */
    if (!propCheck(this, 'size', badgeSizes.join(' | '), vOneOf(badgeSizes)))
      return;
  }
  watchCustomPosition() {
    /* istanbul ignore if */
    if (!propCheck(this, 'customPosition', '{ top?: string; bottom?: string; left?: string; right?: string; }', vUndefOr(vObjectWith({
      top: vUndefOr(vString),
      bottom: vUndefOr(vString),
      left: vUndefOr(vString),
      right: vUndefOr(vString),
    }))))
      return;
  }
  watchHasShadow() {
    /* istanbul ignore if */
    if (!propCheck(this, 'hasShadow', 'boolean', vBoolean))
      return;
  }
  watchIsDot() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isDot', 'boolean', vBoolean))
      return;
  }
  connectedCallback() {
    runWatchers(this);
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    const positionStyle = this.customPosition ? {
      top: this.customPosition.top && this.customPosition.top,
      right: this.customPosition.right && this.customPosition.right,
      left: this.customPosition.left && this.customPosition.left,
      bottom: this.customPosition.bottom && this.customPosition.bottom
    } : {};
    const displayStyle = !this.isDot ? { display: (!this.label || this.label === '') ? 'none' : 'inline-flex' } : {};
    return (h(Host, null, h("slot", null), h("span", { class: "badge", style: Object.assign(Object.assign({}, displayStyle), positionStyle) }, !this.isDot && this.label && this.label)));
  }
  static get watchers() { return {
    "label": ["watchLabel"],
    "version": ["watchVersion"],
    "size": ["watchSize"],
    "customPosition": ["watchCustomPosition"],
    "hasShadow": ["watchHasShadow"],
    "isDot": ["watchIsDot"]
  }; }
};
DsBadge.style = dsBadgeCss;

export { DsBadge as ds_badge };
